import { Component, computed, inject, signal } from "@angular/core"
import { EditorService } from "../services/editor.service"
import { SaveIconComponent } from "../../shared/save-icon.component"
import { Region, regionsData } from "redlineLibs"
import { RegionsEnum } from "redlineLibs"
import { UiRadioComponent } from "ui-radio"
import { UiInheritDirective } from "ui-inherit"
import { UiDialogComponent } from "ui-dialog"
import { Classification, Content, ContentType } from "redlineLibs"
import { FirestoreReadService } from "../../content/firestore-read.service"
import { ProfileService } from "../../user-profile/profile.service"
import { FirestoreWriteService } from "../../content/firestore-write.service"
import { RouteService } from "../../../services/route.service"

type Input = {
  selected: RegionsEnum
  region: RegionsEnum
  label: string
}

@Component({
  imports: [
    SaveIconComponent,
    UiInheritDirective,
    UiRadioComponent,
    UiDialogComponent,
  ],
  standalone: true,
  template: `
    <div>
      Region Export:
    </div>
    @for (input of inputs(); track input.region) {
      <div class="row">
        <lib-ui-radio
          [name]="name"
          [identifier]="input.region"
          [label]="input.label"
          [selected]="input.selected"
          (changes)="change($event)"
        />
        <e2e-save-icon [modelChange]="modelChange()[input.region]"/>
      </div>

      @let region = selectedRegion();
      @if (showExportConfirmationDialog() && region && managerSection()) {
        <lib-ui-dialog
          [transparentBackdrop]="true"
          (cancelAndClose)="showExportConfirmationDialog.set(false)"
        >
          <div ngProjectAs="title">
            Confirm Export
          </div>

          <div ngProjectAs="content">

            <div class="column" style="align-items: center">
              <div>
                Confirm export of this content to: {{ region }}
              </div>
              <div class="row">
                <button
                  class="btn btn-sm btn-accent"
                  (click)="showExportConfirmationDialog.set(false)"
                >
                  Cancel
                </button>
                <button
                  class="btn btn-sm btn-accent"
                  (click)="copyToRegion(region)"
                >
                  Copy to {{ region }}
                </button>
              </div>
            </div>
          </div>
        </lib-ui-dialog>
      }

    }
  `,
  selector: "e2e-editor-region-layout-export",
})
export class EditorRegionLayoutExportComponent {
  private editorService = inject(EditorService)
  private firestoreReadService = inject(FirestoreReadService)
  private firestoreWriteService = inject(FirestoreWriteService)
  private profileService = inject(ProfileService)
  private routeService = inject(RouteService)

  name = "region"
  selectedRegion = signal<RegionsEnum | undefined>(undefined)
  showExportConfirmationDialog = signal(false)
  section = this.routeService.sectionFlags
  managerSection = computed(() => this.section().MANAGER)


  selected = computed(() => this.editorService.editorContent()?.status.region)
  inputs = computed(
    () =>
      ((this.selected() &&
          this.data
            .map(item => {
              return {
                selected: this.selected(),
                region: item.region,
                label: item.label,
              }
            })
        ) || []) as Input[],
  )
  modelChange = signal<{ [key: string]: number }>({})

  change(region: RegionsEnum) {
      this.modelChange.update((model) => ({ ...model, [region]: Date.now() }))
      const content = this.editorService.editorContent()
      if (content && (content.status.region !== region)) {
        this.selectedRegion.set(region)
        this.showExportConfirmationDialog.set(true)
        console.log("set content export to:", region)

        // this.uiAlertService.show.set(true)
        // this.editorService.queueEditor({
        //   ...content,
        //   status: {
        //     ...content.status,
        //     region,
        //   },
        // })
      }
  }

  get data(): Region[] {
    return Object.values(regionsData).filter((region) => region.enabled)
  }

  copyToRegion(region: RegionsEnum) {
    const content = this.editorService.editorContent()
    if (content && region && content.status.region !== region) {
      const user = {
        id: this.profileService.userId(),
        name: this.profileService.userName(),
        role: this.profileService.getUserRole(),
        region,
      }

      const story = this.firestoreReadService.getStoryById(content.id)

      const newContent = this.firestoreReadService
        .newContent(
          user,
          content.status.contentTypes,
          content.status.classification,
          story?.TITLE.value
        )

      // console.log("newContent", {
      //   ...newContent,
      //   status: {
      //     ...newContent.status,
      //     showInteractiveDetails: content.status.showInteractiveDetails,
      //   },
      //   settings: content.settings
      // })

      this.firestoreWriteService.saveContent([{
        ...newContent,
        status: {
          ...newContent.status,
          showInteractiveDetails: content.status.showInteractiveDetails,
        },
        settings: content.settings
      }])
        .then(() => {
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
        })

      this.showExportConfirmationDialog.set(false)

    }
  }
}
